import CompanyCard from "../company/CompanyCard";

export default function MatchHits(props) {
  let { items } = props;

  return Object.values(items)
    // .map((item, index) => <div >{index}</div>);
    .map((item, index) => <CompanyCard key={`card${index}`} item={item} index={index} />);
}